<template>
  <div class="modal fade" id="ispUpdateModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered w-[700px]">
      <div class="modal-content" v-if="local">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Update ISP</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="overflow-hidden">
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              ID:
              <v-text-field v-model="local.id" variant="outlined" density="compact" readonly></v-text-field>
            </div>
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              Sellable:
              <v-switch class="ml-4" v-model="local.sellable" color="success"></v-switch>
            </div>
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              ISP Name:
              <v-text-field v-model="local.name" variant="outlined" density="compact"></v-text-field>
            </div>
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              Country:
              <v-select v-model="local.country" :items="countries.map(c => c.name)" variant="outlined" density="compact"></v-select>
            </div>
            <div class="float-left w-full px-5 h-20 modal-item">
              Replace Image (optional):
              <v-file-input label="Choose an image" accept="image/*" variant="outlined" density="compact"
                @change="onFileChange"></v-file-input>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary" @click="handleUpdate">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from "vue";
import { useAdminIspStore } from "@/stores";

const props = defineProps({
  item: { type: Object, default: null },
  countries: { type: Array, default: () => [] },
});
const emit = defineEmits(["updated"]);

const adminIspStore = useAdminIspStore();
const buttonDisableFlag = ref(false);
const local = ref(null);
const file = ref(null);

watch(
  () => props.item,
  (v) => {
    local.value = v ? { ...v } : null;
    file.value = null;
  },
  { immediate: true }
);

const onFileChange = (event) => {
  const f = event?.target?.files?.[0];
  file.value = f || null;
};

const handleUpdate = async () => {
  if (!local.value) return;
  buttonDisableFlag.value = true;

  if (file.value) {
    const formData = new FormData();
    formData.append("id", String(local.value.id));
    formData.append("name", local.value.name);
    formData.append("country", local.value.country);
    formData.append("sellable", String(!!local.value.sellable));
    formData.append("file", file.value);
    await adminIspStore.updateIsp(formData);
  } else {
    await adminIspStore.updateIsp({
      id: local.value.id,
      name: local.value.name,
      country: local.value.country,
      sellable: !!local.value.sellable,
    });
  }

  buttonDisableFlag.value = false;
  emit("updated");
};
</script>

